export default __webpack_public_path__ + "static/product-listing-management-95cd3d5636e6e81702f35f57fcb2338b.png";